import { Typography } from '@prenuvo/halo';

import { ACTIVITY_LOG_ACTION, ActivityLogDetailValue } from '@/api';
import { Editor } from '@/shared/ui/editor/editor.component';

import { ACTION_CLASSES, ActionClass, EDITOR_FIELDS } from './activity-log.constant';
import { formatValue, shouldRenderArrow } from './activity-log.util';

export interface ActivityLogDetailProps {
  action: ActionClass;
  fieldName?: string;
  oldValue?: ActivityLogDetailValue;
  title: string;
  value: ActivityLogDetailValue;
}

export function ActivityLogDetail({
  action,
  fieldName = '',
  oldValue = null,
  title,
  value,
}: ActivityLogDetailProps) {
  const getActionClassName = (className: ActionClass) => ACTION_CLASSES[className] || '';

  return (
    <div className="pb-2">
      <Typography
        className="pb-2"
        translationKey="FCT.ACTIVITY_LOG.DETAIL.TITLE"
        values={{ title }}
        variant="paragraph-sm"
      />

      <div className="flex">
        {EDITOR_FIELDS.includes(fieldName) ? (
          <>
            {oldValue !== null && (
              <div className={getActionClassName(ACTIVITY_LOG_ACTION.DELETE)}>
                <Editor isReadOnly value={oldValue as string} />
              </div>
            )}
            {shouldRenderArrow(value, oldValue) && (
              <span className="mx-5" data-testid="arrow-seperator">
                &gt;
              </span>
            )}
            <div className={getActionClassName(action)}>
              <Editor isReadOnly value={value as string} />
            </div>
          </>
        ) : (
          <>
            {oldValue !== null && (
              <Typography
                className={getActionClassName(ACTIVITY_LOG_ACTION.DELETE)}
                translationKey="FCT.ACTIVITY_LOG.DETAIL.OLD_VALUE"
                values={{ oldValue: formatValue(oldValue) }}
                variant="paragraph-sm"
              />
            )}

            {shouldRenderArrow(value, oldValue) && (
              <span className="mx-2 leading-none" data-testid="arrow-seperator">
                &gt;
              </span>
            )}

            <Typography
              className={getActionClassName(action)}
              translationKey="FCT.ACTIVITY_LOG.DETAIL.VALUE"
              values={{ value: formatValue(value) }}
              variant="paragraph-sm"
            />
          </>
        )}
      </div>
    </div>
  );
}
